import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const useVagasNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    history.push(`/pages/vagas/processosemaberto/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    history.push('/pages/vagas/processosemaberto/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    history.push(`/pages/vagas/processosemaberto/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
